import {Tr, TrSpace} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {Creature} from "@/store/level/types";
import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {PickArtifactCreaturesNavPanel} from "@/scenes.ui/pick-artifact-creatures-nav-panel";
import {HorizontalStandardPanel} from "@/scenes.ui/horizontal-standard-panel";
import {ChestContentType, ContentDto} from "@/store/chest/types";
import {Keys} from "@/constants/key";
import {ForceUtils} from "@/utils/force-utils";
import {CreatureUtils} from "@/utils/creature-utils";
import Sprite = Phaser.GameObjects.Sprite;
import SpriteUtils from "@/utils/sprite-utils";
import SkillUtils from "@/utils/skill-utils";

export class PickCreaturePanel extends HorizontalStandardPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, c: ContentDto, creatures: Creature[], callback: (creatureId: number) => unknown) {
        super(scene, canvas, Tr('vibor.geroja'));
        this.setDepth(3003);

        let name: string | undefined = undefined;

        switch (c.chestContentType) {
            case ChestContentType.GEMS:
            case ChestContentType.ATTACK_TO_ALL:
            case ChestContentType.DEFENCE_TO_ALL:
            case ChestContentType.HEALTH_TO_ALL:
            case ChestContentType.ATTACK_PERCENT_TO_ALL:
            case ChestContentType.DEFENCE_PERCENT_TO_ALL:
            case ChestContentType.HEALTH_PERCENT_TO_ALL:
                break;
            case ChestContentType.FORCE:
                name = TrSpace('force').toUpperCase() + CreatureUtils.getClassNameGenetive(c.force);
                this.init(SpriteUtils.addSprite(this.scene, 0, -100, Keys.ATLAS_FORCES_LARGE, ForceUtils.getImage(c.force)), name,
                    Tr('pick.who').toUpperCase() + name);
                break;
            case ChestContentType.ATTACK_TO_ONE:
                name = Tr('ataka.plus').toUpperCase() + SkillUtils.formatValue(c.skillToOne);
                this.init(SpriteUtils.addSprite(this.scene, 0, -100, Keys.ATLAS_IC_100, Keys.IC_100_ATTACK), name,
                    Tr('pick.who').toUpperCase() + Tr('ataku').toUpperCase());
                break;
            case ChestContentType.DEFENCE_TO_ONE:
                name = Tr('zaschita.plus').toUpperCase() + SkillUtils.formatValue(c.skillToOne);
                this.init(SpriteUtils.addSprite(this.scene, 0, -100, Keys.ATLAS_IC_100, Keys.IC_100_DEFENCE), name,
                    Tr('pick.who').toUpperCase() + Tr('zaschitu').toUpperCase());
                break;
            case ChestContentType.HEALTH_TO_ONE:
                name = Tr('hlth.plus').toUpperCase() + SkillUtils.formatValue(c.skillToOne);
                this.init(SpriteUtils.addSprite(this.scene, 0, -100, Keys.ATLAS_IC_100, Keys.IC_100_HEALTH), name,
                    Tr('pick.who').toUpperCase() + Tr('zdorove').toUpperCase());
                break;

            case ChestContentType.ATTACK_PERCENT_TO_ONE:
                name = Tr('ataka.plus').toUpperCase() + SkillUtils.formatValue(c.count) + '%';
                this.init(SpriteUtils.addSprite(this.scene, 0, -100, Keys.ATLAS_IC_100, Keys.IC_100_ATTACK), name,
                    Tr('pick.who').toUpperCase() + Tr('ataku').toUpperCase());
                break;
            case ChestContentType.DEFENCE_PERCENT_TO_ONE:
                name = Tr('zaschita.plus').toUpperCase() + SkillUtils.formatValue(c.count) + '%';
                this.init(SpriteUtils.addSprite(this.scene, 0, -100, Keys.ATLAS_IC_100, Keys.IC_100_DEFENCE), name,
                    Tr('pick.who').toUpperCase() + Tr('zaschitu').toUpperCase());
                break;
            case ChestContentType.HEALTH_PERCENT_TO_ONE:
                name = Tr('hlth.plus').toUpperCase() + SkillUtils.formatValue(c.count) + '%';
                this.init(SpriteUtils.addSprite(this.scene, 0, -100, Keys.ATLAS_IC_100, Keys.IC_100_HEALTH), name,
                    Tr('pick.who').toUpperCase() + Tr('zdorove').toUpperCase());
                break;

            case ChestContentType.ARTIFACT:
                name = c.artifactName + ' ' + c.artifactEffect;
                this.init(SpriteUtils.addSprite(this.scene, 0, -100, c.artifactAtlas, c.artifactId), name,
                    (Tr('pick.who').toUpperCase() + c.artifactName.toUpperCase()).toUpperCase());
                break;

            case ChestContentType.HERO_RANK:
                name = Tr('rang') + '+1';
                this.init(SpriteUtils.addSprite(this.scene, 0, -100, Keys.ATLAS_PROFILE, Keys.UI_LEVEL_UP), name,
                    (Tr('pick.who').toUpperCase() + name).toUpperCase());
                break;
            case ChestContentType.SLOT_UNLOCK:
                name = Tr('art.slot');
                this.init(SpriteUtils.addSprite(this.scene, 0, -100, Keys.ATLAS_PROFILE, Keys.UI_ART_SLOT_UNLOCK), name,
                    (Tr('pick.who').toUpperCase() + name).toUpperCase());
                break;
        }

        let creaturesNavPanel = new PickArtifactCreaturesNavPanel(scene, canvas, 0, 130, creatures, (creatureId: number) => {
            if (callback != null) {
                callback(creatureId);
            }
            this.close();
        });

        this.add(creaturesNavPanel);
    }

    private init(sprite: Sprite, name: string, agitation: string) {
        let txt = TextUtils.addTextByFamily(this.scene, name,
            0, -35, '#ffd956', 12, 'normal', 140, Fonts.MYRIADPRO_BOLD);
        let choseCreatureText = TextUtils.addTextByFamily(this.scene, agitation,
            0, 20, '#97ff75', 16, 'normal', 330, Fonts.MYRIADPRO_BOLD);
        this.add([sprite, txt, choseCreatureText]);
    }
}
